const Reflux = require("reflux");

const RDStationIntegrationActions = Reflux.createActions({
  "getStatus": {},
  "deactivate": {},
  "toggleSettings": {},
  "changeSettings": {},
  "saveSettings": {}
});

module.exports = RDStationIntegrationActions;



// WEBPACK FOOTER //
// ./app/screens/Integration/actions/rd-station-integration-actions.js